export default "__VITE_ASSET__8862cddf__"